<template>
	<div class="pageWrapper">
		<el-row>
			<el-col :span="10">
				<div class="panel actionPanel createUserPage">
					<img class="logo" src="../assets/primaryLogo.svg" />
					<div class="signupForm">
						<h1 style="font-weight: bold">Sign Up And Start Automating With 350+ Integrations</h1>
						<p>Please enter your details to create an account.</p>
						<el-alert v-if="oauthSuccess" :closable="false" style="margin-bottom: 12px"
							title="Account Created Successfully"
							description="Your account has been created. Please wait for admin approval before logging in."
							type="success" show-icon>
						</el-alert>

						<el-alert v-if="oauthError" :closable="false" style="margin-bottom: 12px"
							title="Authentication Failed" :description="oauthError" type="error" show-icon>
						</el-alert>
						<el-form ref="form" @keyup.native.enter="createUser" :rules="formRules" label-position="top"
							label-width="100px" :model="signupForm">
							<el-form-item prop="organisationName" label="Organisation">
								<el-select v-model="signupForm.organisationName" filterable clearable
									style="width: 100%" remote no-data-text="No organisation found" reserve-keyword
									placeholder="Search for your organisation" :remote-method="searchOrg"
									:loading="searchingOrg">
									<el-option v-for="org in availableOrgsToSelectFrom" :key="org" :label="org"
										:value="org">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<div style="text-align: center">
									Can't find your organisation?
									<el-button @click="$router.push('/createOrganisation')" style="position: relative"
										type="text">Create one
									</el-button>
								</div>
							</el-form-item>
							<div class="socialSignupSection"
								v-if="!oauthConfigLoading && (oauthConfig.googleEnabled || oauthConfig.microsoftEnabled)">
								<button type="button" class="gsi-material-button signup-google-btn"
									v-if="oauthConfig.googleEnabled" :disabled="!signupForm.organisationName"
									@click="continueWithGoogle">
									<div class="gsi-material-button-state"></div>
									<div class="gsi-material-button-content-wrapper">
										<div class="gsi-material-button-icon">
											<img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
												alt="Google" width="20" height="20" />
										</div>
										<span class="gsi-material-button-contents">
											Continue with Google
										</span>
									</div>
								</button>

								<button type="button" class="ms-login-button ms-signup-button"
									v-if="oauthConfig.microsoftEnabled" :disabled="!signupForm.organisationName"
									@click="continueWithMicrosoft">
									<img src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
										alt="Microsoft" class="ms-icon" />
									<span>Continue with Microsoft</span>
								</button>

								<el-divider>OR</el-divider>
							</div>
							<el-form-item prop="email" label="Email">
								<el-input type="email" placeholder="john.smith@acme.com"
									v-model="signupForm.email"></el-input>
							</el-form-item>
							<el-form-item prop="username" label="Username">
								<el-input placeholder="johnsmith99" v-model="signupForm.username"></el-input>
							</el-form-item>
							<el-form-item prop="password" label="Password">
								<el-input type="password" v-model="signupForm.password"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button @click="createUser" :disabled="!signupForm.password ||
									!signupForm.email ||
									!signupForm.organisationName ||
									!signupForm.username ||
									!emailIsValid ||
									!passwordIsValid
									? true
									: false
									" :loading="operationInProgress" style="width: 100%; margin-top: 12px" type="primary">Sign Up</el-button>
							</el-form-item>
							<el-form-item>
								<div style="text-align: center">
									Already have an account?
									<el-button @click="$router.push('/login')" style="position: relative"
										type="text">Log in now <img class="underline"
											src="../assets/underline.svg" /></el-button>
								</div>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="14">
				<div class="panel contentPanel">
					<mediaCarousel />
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import mediaCarousel from "../components/mediaCarousel.vue";
import { httpHelper } from "../utils/httpHelper.js";
import { passwordMeetsMinRequirements } from "../utils/validation.js";
import email from "../assets/email.svg";
let $this;
export default {
	components: {
		mediaCarousel,
	},
	data() {
		const validateEmail = function (rule, value, callback) {
			var re =
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(String(value).toLowerCase())) {
				callback(new Error("Please enter a valid email"));
				$this.emailIsValid = false;
			} else {
				callback();
				$this.emailIsValid = true;
			}
		};
		const validatePassword = (rule, value, callback) => {
			if (!passwordMeetsMinRequirements(value).passed) {
				$this.passwordIsValid = false;
				return callback(new Error(passwordMeetsMinRequirements(value).error));
			} else {
				$this.passwordIsValid = true;
				return callback();
			}
		};
		return {
			emailImg: email,
			operationInProgress: false,
			emailIsValid: false,
			passwordIsValid: false,
			oauthConfig: null,
			oauthConfigLoading: true,
			signupForm: { email: "", password: "", username: "", organisationName: "" },
			formRules: {
				email: [
					{ required: true, message: "Your email is required", trigger: "change" },
					{ validator: validateEmail, trigger: "change" },
				],
				password: [
					{ required: true, message: "A password is required", trigger: "change" },
					{ validator: validatePassword, trigger: "change" },
				],
				username: [{ required: true, message: "A unique username is required", trigger: "change" }],
				organisationName: [{ required: true, message: "An organisation is required", trigger: "change" }],
			},
			availableOrgs: [],
			availableOrgsToSelectFrom: [],
			searchingOrg: false,
			oauthPopup: null,
			oauthError: null,
			oauthSuccess: false,
		};
	},
	async mounted() {
		$this = this;
		await this.populateAvailableOrganisations();
		window.addEventListener("message", this.handleOAuthMessage);

		const res = await this.httpHelper("RUNTIME", "GET", "security/oauth-config", {});
		this.oauthConfig = res?.response || { googleEnabled: false, microsoftEnabled: false };
		this.oauthConfigLoading = false;
	},
	beforeDestroy() {
		window.removeEventListener("message", this.handleOAuthMessage);
	},
	methods: {
		searchOrg(query) {
			if (query !== "") {
				this.searchingOrg = true;
				setTimeout(() => {
					this.searchingOrg = false;
					this.availableOrgsToSelectFrom = this.availableOrgs.filter((org) => {
						return org.toLowerCase().indexOf(query.toLowerCase()) > -1;
					});
				}, 200);
			} else {
				this.availableOrgsToSelectFrom = [];
			}
		},
		async populateAvailableOrganisations() {
			const query = await httpHelper("RUNTIME", "GET", "security/fetchActiveOrganisations", {});
			if (query && query?.response && Array.isArray(query?.response)) {
				this.availableOrgs =
					query?.response?.map((each) => {
						return each.organisationName;
					}) || [];
			}
		},
		routeToLogin() {
			this.$router
				.push({
					name: "login",
					params: {
						username: this.signupForm.username,
						email: this.signupForm.email,
					},
				})
				.catch(() => { });
		},
		continueWithGoogle() {
			if (!this.signupForm.organisationName) return;

			this.oauthSuccess = false;
			this.oauthError = null;

			const org = encodeURIComponent(this.signupForm.organisationName);

			const width = 500;
			const height = 650;
			const left = window.screenX + (window.outerWidth - width) / 2;
			const top = window.screenY + (window.outerHeight - height) / 2;

			window.open(
				`${process.env.VUE_APP_RUNTIME_ENDPOINT}/security/oauth/google?organisationName=${org}&mode=signup`,
				"GoogleLogin",
				`width=${width},height=${height},left=${left},top=${top}`
			);
		},
		handleOAuthMessage(event) {
			if (!event.data) return;

			if (event.data.type === "oauth_success") {
				this.oauthSuccess = true;
				this.oauthError = null;

				setTimeout(() => {
					this.$router.push("/login");
				}, 500);
			}

			if (event.data.type === "oauth_error") {
				this.oauthError = event.data.message || "Authentication failed.";
				this.oauthSuccess = false;
			}
		},
		continueWithMicrosoft() {
			if (!this.signupForm.organisationName) return;

			this.oauthSuccess = false;
			this.oauthError = null;

			const org = encodeURIComponent(this.signupForm.organisationName);

			const width = 500;
			const height = 650;
			const left = window.screenX + (window.outerWidth - width) / 2;
			const top = window.screenY + (window.outerHeight - height) / 2;

			window.open(
				`${process.env.VUE_APP_RUNTIME_ENDPOINT}/security/oauth/microsoft?organisationName=${org}&mode=signup`,
				"MicrosoftLogin",
				`width=${width},height=${height},left=${left},top=${top}`
			);
		},
		async createUser() {
			this.formRules.username.length === 2 ? this.formRules.username.splice(1, 1) : null;
			this.formRules.email.length === 3 ? this.formRules.email.splice(2, 1) : null;
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					this.operationInProgress = true;
					const result = await httpHelper("RUNTIME", "POST", "security/createUser", this.signupForm);
					setTimeout(() => {
						this.operationInProgress = false;
						if (!result?.error) {
							//Verify email notification
							this.$alert(
								`<img src="${this.emailImg}" class="emailVerify"/><p style="margin-bottom:20px;">We have sent an email to the address provided. You must verify your email before logging in.</p>`,
								"",
								{
									dangerouslyUseHTMLString: true,
									confirmButtonText: "Email Has Been Verified",
									callback: (action) => {
										if (action !== "cancel") {
											this.routeToLogin();
										}
									},
								}
							);
						} else {
							if (result.status === 409) {
								const emailExists = result.error?.response?.data?.error?.emailExists || false;
								const usernameExists = result.error?.response?.data?.error?.usernameExists || false;
								if (usernameExists) {
									this.formRules.username.push({
										validator: (rule, value, callback) => {
											return callback(new Error("Username already in use"));
										},
										trigger: "manual",
									});
								}
								if (emailExists) {
									this.formRules.email.push({
										validator: (rule, value, callback) => {
											return callback(new Error("Email already in use"));
										},
										trigger: "manual",
									});
								}
								this.$refs.form.validate();
							}
						}
					}, 500);
				} else {
					return;
				}
			});
		},
	},
};
</script>

<style scoped>
.pageWrapper {
	min-height: 100vh;
	width: 100vw;
	text-align: left;
}

.createUserPage {
	overflow-y: auto;
	min-height: 100vh;
}

.createUserPage::-webkit-scrollbar {
	display: none;
}

.panel {
	height: 100vh;
	width: 100%;
}

.logo {
	height: 40px;
	margin-left: 20px;
	margin-top: 20px;
}

.actionPanel {
	background-color: white;
}

.contentPanel {
	background-color: #f5f7f9;
}

.signupForm {
	width: 70%;
	max-width: 400px;
	display: block;
	margin: auto;
	margin-top: 12%;
}

.underline {
	height: 8px;
	position: absolute;
	top: 35px;
	left: 0px;
}
</style>

<style>
.socialSignupSection {
	margin-bottom: 20px;
}

.ms-login-button {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	width: 100%;
	height: 40px;
	background-color: #ffffff;
	color: #000000;
	border: 1px solid #8c8c8c;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.2s ease, box-shadow 0.2s ease;
	margin-top: 15px;
	margin-bottom: 37px;
}

.ms-login-button:hover {
	background-color: #f3f3f3;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ms-login-button:active {
	background-color: #e5e5e5;
}

.ms-login-button:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}

.ms-icon {
	width: 18px;
	height: 18px;
}

.orgWarning {
	font-size: 12px;
	color: #e74c3c;
	text-align: center;
	margin-bottom: 10px;
}

.gsi-material-button {
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	-webkit-appearance: none;
	background-color: WHITE;
	background-image: none;
	border: 1px solid #747775;
	-webkit-border-radius: 4px;
	border-radius: 4px;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	color: #1f1f1f;
	cursor: pointer;
	font-size: 14px;
	height: 40px;
	letter-spacing: 0.25px;
	outline: none;
	overflow: hidden;
	padding: 0 12px;
	position: relative;
	text-align: center;
	-webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;
	transition: background-color .218s, border-color .218s, box-shadow .218s;
	vertical-align: middle;
	white-space: nowrap;
	width: 100%;
	min-width: min-content;
}

.gsi-material-button .gsi-material-button-icon {
	height: 20px;
	margin-right: 10px;
	min-width: 20px;
	width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
	-webkit-align-items: center;
	align-items: center;
	display: flex;
	-webkit-flex-direction: row;
	flex-direction: row;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	height: 100%;
	position: relative;
	width: 100%;
	justify-content: center;
}

.gsi-material-button .gsi-material-button-contents {
	font-weight: 500;
	overflow: hidden;
	text-overflow: ellipsis;
	vertical-align: top;
}

.gsi-material-button .gsi-material-button-state {
	-webkit-transition: opacity .218s;
	transition: opacity .218s;
	bottom: 0;
	left: 0;
	opacity: 0;
	position: absolute;
	right: 0;
	top: 0;
}

.gsi-material-button:disabled {
	cursor: default;
	background-color: #ffffff61;
	border-color: #1f1f1f1f;
}

.gsi-material-button:disabled .gsi-material-button-contents {
	opacity: 38%;
}

.gsi-material-button:disabled .gsi-material-button-icon {
	opacity: 38%;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state,
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
	background-color: #303030;
	opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
	-webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
	box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
	background-color: #303030;
	opacity: 8%;
}

.signup-google-btn {
	margin-top: 10px;
}
</style>
